<template>
	<div id="informationList">
		<div class="search-box">
			<input type="text" placeholder="搜索产品型号" v-model="search">
			<button @click="searchList">搜索</button>
		</div>
		<div class="type-box">
            <div class="type">
                <p @click="categoryChange(0)" :class="category==''?'active':''">全部</p>
                <p v-for="(item,index) in categoryArr" @click="categoryChange(item.id)" :class="item.id==category?'active':''">{{item.title}}</p>
            </div>
			<!-- <p v-for="(item,index) in sortList" @click="sortChange(item,index)" :class="item.sort==sort?'active':''">{{item.name}}</p>
            <p>
                <span>筛选<img src="@/assets/images/icon-sx.jpg" alt=""></span>
                <select name="" v-model="category" @change="categoryChange">
                    <option value="">请选择</option>
                    <option :value="item.id" v-for="(item,index) in categoryArr">{{item.title}}</option>
                </select>
            </p> -->
		</div>
		<div class="list">
			<div class="box" v-for="(item,index) in lists">
			<router-link :to="'/mobile/informationPoster?id='+item.id">
				<div class="img"><img :src="item.poster_url" alt=""></div>
				
				<div class="bottom-txt">
					<p style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;">{{item.title}}</p>
					<img src="@/assets/images/icon-share.png" alt="">
				</div>
			</router-link>
			</div>
            <div v-if="lists.length==0" style="text-align: center;line-height: 2rem;">暂无数据</div>
		</div>
		<div class="list-page">
			<p v-for="(item, index) in links" :key="index" v-if="!((item.label=='pagination.previous'||item.label=='pagination.next')&&!item.url)" @click="pageChange(item)" :class="current_page==item.label?'active':item.url?'btn':''">
				<span v-if="item.label=='&laquo; 上一页'">上一页</span>
				<span v-if="item.label!='&laquo; 上一页'&&item.label!='下一页 &raquo;'">{{item.label}}</span>
				<span v-if="item.label=='下一页 &raquo;'">下一页</span>
			</p>
		</div>
	</div>
</template>

<script>
import wxapi from "@/assets/js/wxsdk.js";
export default {
  mounted() {
	  this.getlist();
	  wxapi.wxRegister(this.wxRegCallback)
  },
  data() {
    return {
	  sortList:[
		{name:"最新更新",sort:""},
		{name:"使用最多",sort:1},
		{name:"时间最早",sort:2},
	  ],
	  sort:"",
      categoryArr:"",
      category:"",
	  lists:[],
	  search:"",
	  page:1,
	  current_page:1,
	  links:[],
    }
  },
  components: {
	  
  },
  methods: {
	  wxRegCallback(){
		  wxapi.ShareTimeline({});
		  wxapi.ShareAppMessage({});
	  },
	  sortChange(item,index){
		  this.sort=item.sort;
		  this.page=1;
		  this.getlist();
	  },
      categoryChange(id){
          this.category=id
		  this.page=1;
		  this.getlist();
      },
	  searchList(){
		  this.page=1;
		  this.getlist();
	  },
	  getlist(txt){
		  this.fetchGet(`/api/v1/ent/products`,{
			  page:this.page,
			  search:txt?txt:this.search,
              category:this.category,
			  sort:this.sort,
		  }).then((res) => {
			if(res.code==200){
				this.lists=res.data.data.data;
				this.links=res.data.data.links;
				this.current_page=res.data.data.current_page;
                this.categoryArr=res.data.category
			}
		  })
	  },
	  pageChange(item){
	  	if(item.url && item.label!=this.page){
	  		if(item.label=="&laquo; 上一页"){
	  			this.page=this.current_page-1
	  		}else if(item.label=="下一页 &raquo;"){
	  			this.page=this.current_page+1
	  		}else{
	  			this.page=item.label
	  		}
	  		this.getlist()
	  	}
	  },
  },
}
</script>
<style scoped>
	#informationList .search-box{margin-top: 0.22rem;padding: 0.17rem 0.25rem;background: #fff;overflow: hidden;box-sizing: border-box;}
	#informationList .search-box input{width: 5.72rem;height: 0.62rem;border: 1px solid #000;vertical-align: top;padding: 0 0.22rem;border-right: 0;font-size: 0.24rem;box-sizing: border-box;}
	#informationList .search-box button{width: 1.26rem;height: 0.62rem;padding: 0;text-align: center;font-size: 0.28rem;vertical-align: top;border: 1px solid #000;box-sizing: border-box;}
	
	#informationList .type-box{margin-top: 0.48rem;padding: 0 0.25rem;}
	/* #informationList .type-box::after{clear: both;content: "";display: block;}
	#informationList .type-box p{float: left;width: 1.66rem;height: 0.55rem;line-height: 0.51rem;border: 0.02rem solid #000;font-size: 0.24rem;color: #939393;text-align: center;box-sizing: border-box;margin-right: 0.1rem;cursor: pointer;position: relative;}
	#informationList .type-box p span{display: block;}
	#informationList .type-box p span img{vertical-align: top;margin-top: 0.15rem;margin-left: 0.13rem;width: 0.22rem;}
	#informationList .type-box p select{width: 100%;border: 0;height: 100%;position: absolute;top: 0;left: 0;opacity: 0;}
	#informationList .type-box p:nth-last-of-type(1){margin-right: 0;}
	#informationList .type-box p.active{background: #0096D6;border-color: #0096D6;color: #FFFFFF;} */
    #informationList .type-box .type{overflow: hidden;}
    #informationList .type-box .type p{float: left;font-size: 0.2rem;color: #727272;line-height: 0.22rem;text-align: center;box-sizing: border-box;cursor: pointer;padding: 0 0.23rem;border-left: 0.02rem solid #727272;}
    #informationList .type-box .type p:nth-child(1){border-left: 0;padding-left: 0;}
    #informationList .type-box .type p.active{color: #FF5400;}
	#informationList .list{overflow: hidden;margin-top: 0.3rem;padding: 0 0.25rem;}
	#informationList .list .box{width: 3.4rem;margin-right: 0.18rem;margin-bottom: 0.18rem;float: left;background: #fff;}
	#informationList .list .box:nth-of-type(2n){margin-right: 0;}
	#informationList .list .box .img{width: 100%;height: 5.32rem;overflow: hidden;}
	#informationList .list .box .img img{width: 100%;display: block;}
	#informationList .list .box .bottom-txt{padding: 0.14rem;display: flex;}
	#informationList .list .box .bottom-txt img{width: 0.56rem;height: 0.56rem;flex: 0 0 auto;}
	#informationList .list .box .bottom-txt p{font-size: 0.22rem;line-height: 0.28rem;width: 100%;}
	.list-page{text-align: center;text-align: center;margin: 20px 0;}
	.list-page p{display: inline-block;line-height: 30px;height: 30px;min-width: 30px;box-sizing: border-box;padding: 0 5px;margin: 0 5px;border-radius: 3px;border: 1px solid transparent;cursor: pointer;}
	.list-page p:hover{border: 1px solid #0096D6;}
	.list-page .btn{color: #0096D6;cursor: pointer;}
	.list-page .active{color: #fff;background: #0096D6;}
</style>